import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Password input with an inline eye-icon that toggles visibility.
// Keeps the same look-and-feel (2-px foreground border, brutal focus ring)
// so it drops into login/register without extra styling.
export default function PasswordInput({
  value,
  onChange,
  required = false,
  minLength,
  autoComplete = "current-password",
  placeholder = "",
  className = "",
  testId,
  ariaLabel,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        type={visible ? "text" : "password"}
        required={required}
        minLength={minLength}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        placeholder={placeholder}
        data-testid={testId}
        aria-label={ariaLabel}
        className="w-full border-2 border-foreground bg-background pl-3 pr-10 py-2 font-mono-num focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        aria-label={visible ? "Wachtwoord verbergen" : "Wachtwoord tonen"}
        aria-pressed={visible}
        tabIndex={-1}
        className="absolute inset-y-0 right-0 flex items-center px-2 text-muted-foreground hover:text-foreground focus:outline-none focus:text-primary"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
